import type { RegenerateMfaRecoveryCodesRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useRegenerateMfaRecoveryCodes() {
  return useApiMutation("post", "/auth/mfa/recovery-codes", {
    notify: { error: false },
    mapVariables: (body: RegenerateMfaRecoveryCodesRequestDto) => ({ body }),
  });
}
